<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个参数</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button> -->
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="key" label="健"></el-table-column>
        <el-table-column prop="value" label="值"></el-table-column>
        <el-table-column prop="remark" label="描述"></el-table-column>

        <el-table-column prop="createdTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="margin-left20 color-blue">查看详情</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">编辑</el-button>
            <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="编辑" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-form-item label="键">
            <el-input :disabled="!editMode" v-model="form.key"></el-input>
          </el-form-item>
          <el-form-item label="值">
            <el-input :disabled="!editMode" v-model="form.value"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input :disabled="!editMode" v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <el-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetSystemSettings,
  RemoveSystemSetting,
  SaveSystemSetting
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        no: [{ required: true, message: "请输入编码", trigger: "blur" }],
        name: [{ required: true, message: "请选择名称", trigger: "blur" }],
      },
      cancelButtonText: "禁用",
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0
          ? "启用"
          : "禁用";
    },
    // 获取列表
    getData () {
      GetSystemSettings(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.resetForm();
      this.getDepts("");
      this.editMode = true;
    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      // this.form.state = Boolean(this.form.state);
      this.open = true;
      this.getDepts("");
      this.editMode = true;
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        // this.form.state = Number(this.form.state);
        SaveSystemSetting(this.form)
          .then((res) => {
            // if (res.successful == false) {
            //   this.$my_message(res.errorMessage,"error")
            //   return;
            // }
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => {
            // this.form.state = Boolean(this.form.state);
          });
      });
    },
    resetForm () {
      this.form = {
        key: "",
        value: '',
        remark: '',
        state: 1,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      // let ids = [];
      // let state = 0;
      // if (row && row.id) {
      //   ids = [row.id];
      //   state = row.state == 1 ? 0 : 1;
      // } else {
      //   let states = this.multipleSelection.map((e) => e.state);
      //   if (states.length > 1) {
      //     this.$my_message("请只选择一种状态的数据！", "warning");
      //     return;
      //   }
      //   ids = this.ids;
      //   state = this.multipleSelection[0].state == 1 ? 0 : 1;
      // }
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm(
        "确认删除当前参数吗",
        "提示",
        {
          type: "warning",
        }
      )
        .then(() => {
          return RemoveSystemSetting({ ids, state });
        })
        .then(() => {
          this.$my_message(`操作成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        name: "",
        state: 1,
        pageIndex: 1,
        pageSize: 10,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    deptChange (val) {
      this.form.parentId = val;
    },
    userChange (val) {
      this.form.leader = val;
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
